export default __webpack_public_path__ + "static/media/Average.29ea12cf.svg";